

export class BranchDetailOutput implements IBranchDetailOutput {
    /** The auto-generated id of the tbl_branch_detail */
    branch_detail_id!: number;
    /** The auto-generated id of the tbl_company_details */
    company_details_id!: number;
    /** The branch code with 100 character limit */
    branch_code!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The street 1 with 255 character limit */
    street_1!: string;
    /** The street 2 with 255 character limit */
    street_2!: string;
    /** The Reference id of the tbl_city table */
    city_id!: number;
    /** The ZIP code with 6 character limit */
    zip_code!: string;
    /** The contact person with 255 character limit */
    contact_person!: string;
    /** The email id of user with 320 character limit */
    email!: string;
    /** The telephone number with 13 character limit */
    telephone_number!: string;
    /** The mobile number with 10 character limit */
    mobile_number!: string;
    /** The fax number with 20 character limit */
    fax_number!: string;
    /** The telephone number with 2000 character limit */
    description!: string;
    /** Manage status of branch. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated creating time of tbl_branchDetail item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_branchDetail item add or update */
    updating_date!: any;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The city name with 255 character limit */
    city_name!: string;
    /** The Reference id of the tbl_state table */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The Reference id of the tbl_country table */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;

    constructor(data?: IBranchDetailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_code = _data["branch_code"];
            this.branch = _data["branch"];
            this.street_1 = _data["street_1"];
            this.street_2 = _data["street_2"];
            this.city_id = _data["city_id"];
            this.zip_code = _data["zip_code"];
            this.contact_person = _data["contact_person"];
            this.email = _data["email"];
            this.telephone_number = _data["telephone_number"];
            this.mobile_number = _data["mobile_number"];
            this.fax_number = _data["fax_number"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
            this.company_name = _data["company_name"];
            this.city_name = _data["city_name"];
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
        }
    }

    static fromJS(data: any): BranchDetailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_code"] = this.branch_code;
        data["branch"] = this.branch;
        data["street_1"] = this.street_1;
        data["street_2"] = this.street_2;
        data["city_id"] = this.city_id;
        data["zip_code"] = this.zip_code;
        data["contact_person"] = this.contact_person;
        data["email"] = this.email;
        data["telephone_number"] = this.telephone_number;
        data["mobile_number"] = this.mobile_number;
        data["fax_number"] = this.fax_number;
        data["description"] = this.description;
        data["status"] = this.status;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        data["company_name"] = this.company_name;
        data["city_name"] = this.city_name;
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        return data; 
    }
}

export interface IBranchDetailOutput {
    /** The auto-generated id of the tbl_branch_detail */
    branch_detail_id: number;
    /** The auto-generated id of the tbl_company_details */
    company_details_id: number;
    /** The branch code with 100 character limit */
    branch_code: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The street 1 with 255 character limit */
    street_1: string;
    /** The street 2 with 255 character limit */
    street_2: string;
    /** The Reference id of the tbl_city table */
    city_id: number;
    /** The ZIP code with 6 character limit */
    zip_code: string;
    /** The contact person with 255 character limit */
    contact_person: string;
    /** The email id of user with 320 character limit */
    email: string;
    /** The telephone number with 13 character limit */
    telephone_number: string;
    /** The mobile number with 10 character limit */
    mobile_number: string;
    /** The fax number with 20 character limit */
    fax_number: string;
    /** The telephone number with 2000 character limit */
    description: string;
    /** Manage status of branch. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated creating time of tbl_branchDetail item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_branchDetail item add or update */
    updating_date: any;
    /** The company name with 255 character limit */
    company_name: string;
    /** The city name with 255 character limit */
    city_name: string;
    /** The Reference id of the tbl_state table */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** The Reference id of the tbl_country table */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
}

